import React, { memo, useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Lightbox from './Lightbox';
import MessageBox from './MessageBox';
import RefillDialog from './RefillDialog';
import PhoneVerificationDialog from 'components/phoneVerification/PhoneVerificationDialog';
import ReleaseNotesDialog from './ReleaseNotesDialog';
import IdentityVerificationDialog from './IdentityVerificationDialog';

// Memoized dialog components to prevent unnecessary re-renders
const MemoizedLightbox = React.memo(Lightbox);
const MemoizedMessageBox = React.memo(MessageBox);
const MemoizedRefillDialog = React.memo(RefillDialog);
const MemoizedPhoneVerificationDialog = React.memo(PhoneVerificationDialog);
const MemoizedReleaseNotesDialog = React.memo(ReleaseNotesDialog);
const MemoizedIdentityVerificationDialog = React.memo(IdentityVerificationDialog);

const Dialogs = () => {
  // Select dialog states from Redux to conditionally render only active dialogs
  const lightboxState = useSelector((state) => state.lightbox, shallowEqual);
  const messageBoxState = useSelector((state) => state.messagebox, shallowEqual);
  const refillState = useSelector((state) => state.refill, shallowEqual);
  const verificationState = useSelector((state) => state.verification, shallowEqual);

  // Determine which dialogs should be rendered based on their state
  const shouldRenderLightbox = useMemo(() => {
    return lightboxState && (lightboxState.docs || lightboxState.docs.length);
  }, [lightboxState]);

  const shouldRenderMessageBox = useMemo(() => {
    return messageBoxState && (messageBoxState.message || messageBoxState.callback);
  }, [messageBoxState]);

  const shouldRenderRefillDialog = useMemo(() => {
    return refillState && refillState.callback;
  }, [refillState]);

  const shouldRenderPhoneVerification = useMemo(() => {
    return verificationState && verificationState.dialogOpen;
  }, [verificationState]);

  return (
    <>
      {shouldRenderLightbox && <MemoizedLightbox />}
      {shouldRenderMessageBox && <MemoizedMessageBox />}
      {shouldRenderRefillDialog && <MemoizedRefillDialog />}
      {shouldRenderPhoneVerification && <MemoizedPhoneVerificationDialog />}
      <MemoizedReleaseNotesDialog />
      <MemoizedIdentityVerificationDialog />
    </>
  );
};

// Memoize the entire Dialogs component
export default memo(Dialogs);
